module["exports"] = ["#{street_suffix} #{Name.first_name}", "#{street_suffix} #{Name.first_name} #{Name.last_name}"];